module.exports = __webpack_public_path__ + "static/team3-6e24691ddf7d8d45d3692cc79222096c.jpg";